<template>
  <div class="map">
    <!-- <div class="iframe_whole"><Iframe :key="$store.state.loginStateKey" :url="`${this.$FN.publicUrl}/page/map`" /></div> -->
    <a-row class="whole" :gutter="20">
      <a-col :span="4">
        <AntGridSkeleton :loading="loading" height="1rem" :num="20" :rows="20" :gap="1">
          <div class="language">
            <span>国家</span>
            <a-switch v-model="acquiesce" default-checked @change="change" />
            <span>国际标准化组织</span>
          </div>
        </AntGridSkeleton>
        <Swiper :data="data" />
      </a-col>
      <a-col :span="20">
        <AntBlockSkeleton height="33rem" :loading="loading"></AntBlockSkeleton>
        <Content :data="data" :acquiesce="acquiesce" />
      </a-col>
    </a-row>
  </div>
</template>

<script>
import Swiper from './swiper';
import Content from './content';
export default {
  components: { Swiper, Content },
  data() {
    return {
      acquiesce: true,
      loading: true,
      data: []
    }
  },
  created() {
    this.getData()
  },
  methods: {
    change(value = false) { this.acquiesce = value },
    getData() {
      this.$FN.get("api/product_service/standard/worldMap").then(res => {
        this.loading = false;
        if (res) {
          let { entity = [] } = res;
          this.data = entity;
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import url("./index.less");
</style>